import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import texts from 'Components/texts.json';
import styles from 'Components/VehicleList/NoSale/NoSale.module.scss';
import { useNoSaleCTAButton } from 'Components/VehicleList/NoSale/useNoSaleCTAButton';
import useNoSaleTitle from 'Components/VehicleList/NoSale/useNoSaleTitle';
import { useListType } from 'Stores/ListStore/ListStore';

import useNoSaleMessage from './useNoSaleMessage';

T.setTexts(texts);
export interface NoSaleProps {
	buttonTextProp?: string;
	messageProp?: string;
	titleProp?: string;
}

const NoSale: React.FC<NoSaleProps> = ({ buttonTextProp, messageProp, titleProp }: NoSaleProps) => {
	const listType = useListType();
	const { buttonText, onCTAButtonClick, shouldShowCTAButton } = useNoSaleCTAButton(buttonTextProp);
	const title = useNoSaleTitle({ listType, titleProp });
	const message = useNoSaleMessage({ listType, messageProp });

	return (
		<>
			<h2 className={styles.noSale}>{title}</h2>
			{title && (
				<h3
					className={cx(styles.newVehiclesSoon, shouldShowCTAButton ? styles.withCTAButton : styles.withoutCTAButton)}
				>
					{message}
				</h3>
			)}
			{title && shouldShowCTAButton && (
				<div className={cx(styles.ctaButton)}>
					<Button label={buttonText} onClick={onCTAButtonClick} size="medium" />
				</div>
			)}
		</>
	);
};

export default NoSale;
